module.exports = __webpack_public_path__ + "static/media/END CAP PLAIN END 57 MM FOR 290 TUBE FOR SDS 300.97f5d6b3.jpg";